// bao migrate skip

import TabPage from "./../factories/tab-page";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-tabs";
import "./../bindings/bao-searcher";
import "./../bindings/bao-tree";
import "./../services/bao-router";
import "./../factories/tree-node";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";

import TreeNodeViewModel from "./../factories/tree-node";
import baoRouter from "./../services/bao-router";
class Reminder extends BaseViewModelModule {
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.subscribe(this.SelectedConfigurationItem, () => {
            this.ConfigurationItemChanged(this.SelectedConfigurationItem());
        });
        this.TabController;
        this.ChooseAPerson.subscribe((newValue) => {
            if (newValue == "0") {
                var a = this.ConfigurationItemTypeId;
                this.TemplateDependsOnPerson(false);
            }
            else {
                this.TemplateDependsOnPerson(true);
                if (this.ConfigurationItemTypeCategoryKey() == "Person") {
                    this.AffectedPersonId(this.ConfigurationItemId());
                    //this.AffectedPersonName(this.PersonFullName());
                    this.AffectedPersonName(this.ConfigurationItemName());
                }
                if (this.ConfigurationItemTypeCategoryKey() == "Object") {
                    this.AffectedPersonId(this.OwnerId());
                    this.AffectedPersonName(this.OwnerName());
                }
            }
        });
        this.ConfigurationItemName.subscribe((newValue) => {
            Bao.post("ConfigurationItem/GetConfigurationItemTypeCategoryNameByConfigurationItemId", JSON.stringify({ configurationItemId: this.ConfigurationItemId() }), (result) => {
                if (result == null) {
                    this.ConfigurationItemTypeCategoryKey("");
                    this.OwnerId(null);
                    this.OwnerName("");
                }
                else {
                    this.ConfigurationItemTypeCategoryKey(result.CategoryKey);
                    this.OwnerId(result.OwnerId);
                    this.OwnerName(result.OwnerName);
                    if (this.ConfigurationItemTypeCategoryKey() == "Customer") {
                        this.AffectedPersonId(this.ConfigurationItemId());
                        this.AffectedPersonName(this.ConfigurationItemName());
                    }
                    else {
                        if (this.ConfigurationItemTypeCategoryKey() == "Person") {
                            if (this.ChooseAPerson() == "1") {
                                this.AffectedPersonId(this.ConfigurationItemId());
                                //this.AffectedPersonName(this.PersonFullName());
                                this.AffectedPersonName(this.ConfigurationItemName());
                            }
                        }
                        else {
                            if (this.ConfigurationItemTypeCategoryKey() == "Object") {
                                if (this.ChooseAPerson() == "1") {
                                    this.AffectedPersonId(this.OwnerId());
                                    this.AffectedPersonName(this.OwnerName());
                                }
                            }
                        }
                    }
                }
            });
        });
        this.TemplateDependsOnPerson.subscribe((newValue) => {
            if (newValue) {
                this.ChooseAPerson("1");
            }
            else {
                this.ChooseAPerson("0");
            }
        });
    }
    //Hinzugefügt für automatische Ticketgenerierung
    Subject: KnockoutObservable<string>;
    tabPageEscalation: any;
    SetReactedButtonVisible = ko.observable(false);
    TicketActivated = ko.observable(false);
    TabIsActiveName2: KnockoutObservable<string> = ko.observable("");
    ChooseAPerson = ko.observable("0");
    TemplateDependsOnPerson = ko.observable<boolean>();
    ConfigurationItemTypeCategoryKey = ko.observable<string>();
    ConfigurationItemTypeId = ko.observable<string>();
    AffectedPersonName: KnockoutObservable<string> = ko.observable<string>();
    AffectedPersonId: KnockoutObservable<string> = ko.observable<string>();
    OwnerPersonId = ko.observable<string>();
    OwnerId = ko.observable<string>();
    OwnerPersonName: KnockoutObservable<string> = ko.observable<string>();
    OwnerName: KnockoutObservable<string> = ko.observable<string>();
    OwnerServiceProviderId = ko.observable<string>();
    OwnerServiceProviderName: KnockoutObservable<string> = ko.observable<string>();
    DispatcherPersonId = ko.observable<string>();
    DispatcherPersonName: KnockoutObservable<string> = ko.observable<string>();
    DispatcherServiceProviderId = ko.observable<string>();
    DispatcherServiceProviderName: KnockoutObservable<string> = ko.observable<string>();
    TicketApproveStateId = ko.observable<string>();
    ApprovalRequired = ko.observable<boolean>();
    TicketStatusId = ko.observable<string>();
    TicketStatusName: KnockoutObservable<string> = ko.observable<string>();
    TicketCategoryStructureId = ko.observable<string>();
    TicketCategoryStructureName: KnockoutObservable<string> = ko.observable<string>();
    TicketServiceStructureName: KnockoutObservable<string> = ko.observable("");
    TicketServiceStructureId: KnockoutObservable<string> = ko.observable("");
    TicketStatusWaitsForApproval = "3a9a5ead-53ad-48d7-8ed4-abfa95516018";
    ApprovalAllowed = ko.observable();
    TicketPriorityId = ko.observable<string>();
    TicketTypeId = ko.observable<string>();
    Bao = Bao;
    ConfigurationItemName: KnockoutObservable<string> = ko.observable<string>();
    ConfigurationItemTypeName: KnockoutObservable<string> = ko.observable<string>();
    CustomerName: KnockoutObservable<string>;
    BuildingName: KnockoutObservable<string>;
    DocumentTab: TabPage;
    ChecklistTab: TabPage;
    ConfigurationItemOpenUrl: KnockoutObservable<string>;
    IsCompleteDefault: KnockoutObservable<boolean>;
    IsComplete: KnockoutObservable<boolean> = ko.observable(false);
    ReminderIntervalReadOnly = ko.observable(false);
    ConfigurationItemReminderId = ko.observable<string>();
    ServiceProviderId = ko.observable<string>();
    ContractId = ko.observable<string>();
    ConfigurationItemId = ko.observable<string>();
    SelectedConfigurationItem = ko.observable<any>();
    TimeUnitId = ko.observable<string>();
    ReminderTypeId = ko.observable<string>();
    TargetDateJs = ko.observable<string>();
    ReminderInterval = ko.observable<number>();
    CompleteDateJs = ko.observable<string>();
    CheckwareTaskForerun = ko.observable<number>();
    FolderStructureChecklistId = ko.observable<string>();
    PersonId = ko.observable<string>();
    PersonFullName = ko.observable<string>();
    Enable_Checkware = ko.observable<boolean>();
    PersonSearchEnabledBinding = ko.observable<boolean>();
    PersonSearchEnabled = ko.computed(() => {
        this.PersonSearchEnabledBinding(this.ServiceProviderId() != null);
        return this.PersonSearchEnabledBinding();
    });
    GotoConfigurationItem = () => {
        if (this.ConfigurationItemOpenUrl() != "") {
            baoRouter.setHash(this.ConfigurationItemOpenUrl());
        }
    };
    //Bindings
    SearcherServiceProvider: Bindings.baoSearcher = {
        ObjectId: this.ServiceProviderId,
        ObjectValue: 'ServiceProvider',
        SearchType: 'ServiceProvider',
        AutoSearch: true,
        AutoComplete: true,
        ValueDeleted: () => {
            this.PersonId(null);
            this.PersonFullName(null);
        }
    };
    SearcherPerson: Bindings.baoSearcher = {
        ObjectId: this.PersonId,
        ObjectValue: 'FullName',
        SearchType: 'Person',
        CustomFilter: {
            ServiceProviderId: this.ServiceProviderId
        },
        Enabled: this.PersonSearchEnabledBinding,
        AutoSearch: true,
        AutoComplete: true
    };
    SearcherContract: Bindings.baoSearcher = {
        ObjectId: this.ContractId,
        ObjectValue: 'Name1',
        AutoComplete: true,
        SearchType: 'Contract'
    };
    SearcherConfigurationItem: Bindings.baoSearcher = {
        ObjectId: this.ConfigurationItemId,
        ObjectValue: 'Name1',
        SearchType: 'ConfigurationItemAll',
        SelectedItem: this.SelectedConfigurationItem,
        ValueDeleted: this.ConfigurationItemDeleted,
        GotoVisible: Bao.Session.HasPermission('ConfigurationItemSearch', '1A38B671-948C-42EE-B80D-F6B9A12814B6'),
        Goto: this.GotoConfigurationItem,
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false }
    };
    SearcherTimeUnit: Bindings.baoSearcher = {
        ObjectId: this.TimeUnitId,
        ObjectValue: 'Name',
        AutoComplete: true,
        SearchType: 'TimeUnit',
        AutoSearch: true,
        Enabled: !this.ReminderIntervalReadOnly() //TODO: evtl. ändern, wenn nichts korrekt akutalisiert wird!
    };
    SearcherReminderType: Bindings.baoSearcher = {
        ObjectId: this.ReminderTypeId,
        ObjectValue: 'Type',
        SearchType: 'ReminderType',
        AutoSearch: true,
        AutoComplete: true
    };
    SearcherFolderStructureChecklist: Bindings.baoSearcher = {
        ObjectId: this.FolderStructureChecklistId,
        ObjectValue: 'ListName',
        SearchType: 'Checkware-FolderStructureChecklist',
        AutoComplete: true,
        AutoSearch: true
    };
    DateTimeBoxTargetDate: Bindings.baoDateTimeBox = {
        value: this.TargetDateJs,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerTargetDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    NumberBoxReminderInterval: Bindings.baoNumberBox = {
        value: this.ReminderInterval,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxCompleteDate: Bindings.baoDateTimeBox = {
        value: this.CompleteDateJs,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimePickerCompleteDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    NumberBoxCheckwareTaskForerun: Bindings.baoNumberBox = {
        value: this.CheckwareTaskForerun,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    //End Bindings
    //Functions / Events
    ConfigurationItemChanged(item) {
        this.ConfigurationItemTypeName(item.ConfigurationItemTypeName);
        this.CustomerName(item.CustomerName);
        this.BuildingName(item.BuildingName);
        this.ConfigurationItemOpenUrl(item.OpenUrl);
    }
    ConfigurationItemDeleted() {
        this.ConfigurationItemTypeName("");
        this.CustomerName("");
        this.BuildingName("");
        this.ConfigurationItemOpenUrl("");
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (ko.unwrap(this.Subject) === null || ko.unwrap(this.Subject) === "") {
            isComplete = false;
        }
        if (ko.unwrap(this.ReminderTypeId) === null || ko.unwrap(this.ReminderTypeId) === "") {
            isComplete = false;
        }
        if (ko.unwrap(this.TargetDateJs) === null || ko.unwrap(this.TargetDateJs) === "") {
            isComplete = false;
        }
        if (ko.unwrap(this.ConfigurationItemId) === null || ko.unwrap(this.ConfigurationItemId) === "" || ko.unwrap(this.ConfigurationItemId) === "00000000-0000-0000-0000-000000000000 ") {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "Reminder/Init";
    }
    Save() {
        let extendReminder = false;
        if (this.IsComplete() && (this.IsCompleteDefault() == null || this.IsCompleteDefault() == false) &&
            this.ReminderInterval() != null && this.ReminderInterval() > 0) {
            var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("ReminderExtend"), "yesno");
            yesNoDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    extendReminder = true;
                }
                super.Save().then(() => {
                    if (extendReminder) {
                        return this.ExtendReminder();
                    }
                    return null;
                });
            });
        }
        else {
            return super.Save();
        }
    }
    private ExtendReminder() {
        this.TabPage.IsLoading(true);
        return Bao.post("Reminder/Extend", JSON.stringify({
            configurationItemReminderId: this.ConfigurationItemReminderId()
        })).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    initConfigurationItem(configurationItemId) {
        this.TabPage.IsLoading(true);
        return Bao.post("Reminder/InitConfigurationItem", JSON.stringify({ configurationItemId: configurationItemId }), (result) => {
            this.ConfigurationItemId(configurationItemId);
            this.ConfigurationItemName(result);
            this.TabPage.IsLoading(false);
        });
    }
    loaded() {
        super.loaded();
    }
    init() {
        var configurationItemId = baoRouter.getRouteValue("configurationitemid", this.TabPage);
        return super.init().then(() => {
            return super.InitTabController().then(() => {
                this.DocumentTab = new TabPage();
                this.DocumentTab.IsClosable(false);
                this.DocumentTab.Url("ReminderReferenceDocument");
                this.TabController.AddTab(this.DocumentTab);
                if (this.Enable_Checkware() == true) {
                    this.ChecklistTab = new TabPage();
                    this.ChecklistTab.IsClosable(false);
                    this.ChecklistTab.Url("ChecklistReminderTab");
                    this.ChecklistTab.AutoSelect = false;
                    this.TabController.AddTab(this.ChecklistTab);
                }
            }).then(() => {
                if (configurationItemId != null) {
                    return this.initConfigurationItem(configurationItemId).then(() => {
                        super.loaded();
                    });
                }
            });
        });
    }
    DeleteService() {
        this.TicketServiceStructureName(null);
        this.TicketServiceStructureId(null);
        this.ApprovalRequired(false);
        this.TicketApproveStateId(null);
        //tabPageEscalation.ViewModel().UpdateTicketEscalationDefinition();
        //this.UpdateEscalation();
    }
    ;
    OpenTreeDialog(type) {
        this.TabPage.IsLoading(true);
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({ type: type }), (value) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var dialogViewModel: any = {};
            dialogViewModel.NodeToggled = function (node) {
                // LoadChildren if not loaded
                if (node.Loaded() == false) {
                    this.TabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({ type: type, parentId: parentId }), (value) => {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        this.TabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(() => {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = () => {
                this.TabPage.IsLoading(true);
                var selectedNode;
                //ursprünglich switch
                selectedNode = dialogViewModel.SelectedService();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({ selectedTicketServiceId: selectedNode.Id() }), (result) => {
                            this.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                            this.TicketServiceStructureId(result.TicketServiceStructureId);
                            //this.IsApprovalAllowed();
                            this.OwnerPersonId(result.OwnerUserId);
                            this.OwnerPersonName(result.OwnerUserName);
                            this.OwnerServiceProviderId(result.OwnerRoleId);
                            this.OwnerServiceProviderName(result.OwnerRoleName);
                            this.DispatcherPersonId(result.DispatcherUserId);
                            this.DispatcherPersonName(result.DispatcherUserName);
                            this.DispatcherServiceProviderId(result.DispatcherRoleId);
                            this.DispatcherServiceProviderName(result.DispatcherRoleName);
                            ////Approval
                            //this.TicketApproveStateId(null);
                            //this.ApprovalRequired(result.ApprovalRequired);
                            //if (this.ApprovalRequired() == true) {
                            //    this.TicketStatusId(this.TicketStatusWaitsForApproval);
                            //    ko.utils.arrayForEach(this.TicketStatuses(), (ticketStatus: any) => {
                            //        if (ticketStatus.Key() == this.TicketStatusWaitsForApproval) {
                            //            this.TicketStatusName(ticketStatus.Value());
                            //        }
                            //    });
                            //}
                            if (this.TicketCategoryStructureId() == null) {
                                this.TicketCategoryStructureId(result.TicketCategoryStructureId);
                                this.TicketCategoryStructureName(result.TicketCategoryStructureName);
                            }
                            //dialog.ViewModel().Nodes(null);
                            //dialog.ViewModel(null);
                            //dataSource = null;
                            dialog.Close();
                            //dialog = null;
                            //tabPageEscalation.ViewModel().UpdateTicketEscalationDefinition();
                            //this.UpdateEscalation();
                            this.TabPage.IsLoading(false);
                            selectedServiceSubscription.dispose();
                            selectedServiceSubscription = null;
                            dialogViewModel.SelectedService(null);
                        });
                    }
                }
                this.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                return null;
            };
            dialog.Width("500px");
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            //dialog.Buttons([{ Title: Bao.Session.GetMessage("msgOk"), Enabled: true, Click: dialogViewModel.okClick }]);
            dialog.Open();
            this.TabPage.IsLoading(false);
            dialog.SetPosition();
        });
    }
    IsApprovalAllowed() {
        return Bao.post("Ticket/IsApprovalAllowed", JSON.stringify({ ticketServiceStructureId: this.TicketServiceStructureId() }), function (result) {
            this.ApprovalAllowed(result);
        });
    }
    ;
    InitializeDataBindingTicketServiceStructure(id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({ id: id }), (value) => {
            this.TicketServiceStructureName(value);
        });
    }
    ;
    //UpdateEscalation() {
    //    var model = ko.map.toJS(this, true);
    //    this.TabPage.IsLoading(true);
    //    return Bao.post("Ticket/SetTicketEscalationByTicket", JSON.stringify({
    //        ticketModel: model,
    //        sessionTabId: this.TabPage.SessionTabId
    //    }), (result) => {
    //        if (result != null && result.TicketId != null && this.tabPageEscalation != null) {
    //            this.tabPageEscalation.ViewModel().SetValuesByModel(result);
    //        }
    //        this.UpdateReactedButtonVisible().then(() => {
    //            this.TabPage.IsLoading(false);
    //        });
    //    });
    //};
    UpdateReactedButtonVisible() {
        var model = ko.map.toJS(this, true);
        return Bao.post("Ticket/IsSetReactedButtonVisible", JSON.stringify({
            ticketModel: model,
            sessionTabId: this.TabPage.SessionTabId
        }), (result2) => {
            this.SetReactedButtonVisible(result2);
        });
    }
    ;
}
export default Reminder;